// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"e549d428","274":"2d25a3af","448":"c0de68c4","450":"e0dae15f","509":"ee8ab94e","694":"6b6edbc4","786":"5f353ef2","909":"56779ead"}[chunkId] + ".chunk.js";
};